import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import { DomainDesignation } from "@constants";
import { smoothAfterEnter, smoothEnter, smoothLeave } from "@utils/Routing";
import domainDisplay from "@public-client/Components/Program/Program.Performance.Domain.vue";
import domainIndicatorDisplay from "./StateReport.Performance.DomainIndicator.vue";
import programDesignations from "./StateReport.ProgramDesignations.vue";
export default {
  components: {
    domainDisplay,
    domainIndicatorDisplay,
    programDesignations
  },
  data() {
    return {
      DomainDesignation: DomainDesignation
    };
  },
  computed: {
    overall() {
      return this.$store.state.overallDomain;
    },
    overallWhy() {
      return this.$store.getters.overallDomainWhy;
    },
    domains() {
      return this.$store.state.domains;
    },
    routeDomain() {
      return this.$route.query.domain > 0 ? this.domains.find(x => x.DomainId == this.$route.query.domain) : null;
    },
    transitionName() {
      return this.routeDomain ? "slide-left" : "slide-right";
    },
    designations() {
      let data = [];
      for (let key in DomainDesignation) data.push(DomainDesignation[key]);
      return data;
    },
    facts() {
      const programId = +this.$route.query.programId || 0;
      if (programId > 0) {
        const programFacts = this.$store.getters.stateSummary?.ProgramFacts || [];
        const program = programFacts.find(x => x.ProgramId === programId);
        return program ? program.Facts : [];
      } else {
        return this.$store.getters.stateSummary.Facts;
      }
    }
  },
  methods: {
    leave: smoothLeave,
    enter: smoothEnter,
    afterEnter: smoothAfterEnter,
    enterCancelled: smoothAfterEnter,
    setDomain(e, domain) {
      if (e) e.preventDefault();
      $("[data-toggle='tooltip']").tooltip("hide");
      this.$router.push({
        query: {
          domain: domain.DomainId
        }
      });
      this.$refs.scrollPoint.scrollIntoView({
        // behavior: "smooth",
        block: "nearest"
      });
    },
    clearDomain(e) {
      if (e) e.preventDefault();
      this.$router.push({
        query: {}
      });
    },
    showVideoModal(e) {
      e.preventDefault();
      this.$store.dispatch("openVideoModal", true);
    }
  }
};